
import { initialLoads } from '../data/loads';
import { floors } from '../data/floorData';
import { useLoadToggle } from './useLoadToggle';
import { useFloorSelection } from './useFloorSelection';
import { useScheduleManagement } from './useScheduleManagement';
import { useRecommendations } from './useRecommendations';
import { useViewMode } from './useViewMode';

export const useLoadControl = () => {
  const { loads, setLoads, handleToggleStatus } = useLoadToggle(initialLoads);
  const { selectedFloor, setSelectedFloor, selectedZone, setSelectedZone, getFloorLoads } = useFloorSelection(loads);
  const { isSchedulingOpen, selectedLoad, openScheduling, closeScheduling, handleSaveSchedule } = useScheduleManagement(loads, setLoads);
  const { activeRecommendation, toggleRecommendation, implementRecommendation } = useRecommendations(loads, setLoads);
  const { viewMode, setViewMode } = useViewMode();

  return {
    loads,
    floorLoads: getFloorLoads(),
    isSchedulingOpen,
    selectedLoad,
    activeRecommendation,
    selectedFloor,
    setSelectedFloor,
    selectedZone,
    setSelectedZone,
    viewMode,
    setViewMode,
    floors,
    handleToggleStatus,
    openScheduling,
    handleSaveSchedule,
    toggleRecommendation,
    implementRecommendation,
    closeScheduling
  };
};
